import Icon from '@ant-design/icons'
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

const Svg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <path
      d="M746.666667 810.666667m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z"
      fill="currentColor"
    />
    <path
      d="M867.626667 597.333333h-241.92l-119.978667 213.333334 119.978667 213.333333h241.92l119.978666-213.333333-119.978666-213.333334z m-49.92 85.333334l71.978666 128-72.021333 128H675.626667L603.605333 810.666667l71.978667-128h142.122667z"
      fill="currentColor"
    />
    <path
      d="M874.666667 170.666667a64 64 0 0 1 63.701333 57.856l0.298667 6.144v237.610666a42.666667 42.666667 0 0 1-85.034667 4.949334l-0.298667-4.949334V256h-597.333333v597.333333h173.056a42.666667 42.666667 0 0 1 42.410667 37.674667l0.256 4.992a42.666667 42.666667 0 0 1-37.674667 42.368l-4.992 0.298667H234.666667a64 64 0 0 1-63.701334-57.856L170.666667 874.666667v-640a64 64 0 0 1 57.856-63.701334l6.144-0.298666h640z"
      fill="currentColor"
    />
    <path
      d="M704 0a64 64 0 0 1 63.701333 57.856l0.298667 6.144v139.008h-85.333333V85.333333h-597.333334v597.333334h120.32v85.333333h-141.653333a64 64 0 0 1-63.701333-57.856L0 704v-640a64 64 0 0 1 57.856-63.701333l6.144-0.298667h640z"
      fill="currentColor"
    />
    <path
      d="M384 426.666667m42.666667 0l256 0q42.666667 0 42.666666 42.666666l0 0q0 42.666667-42.666666 42.666667l-256 0q-42.666667 0-42.666667-42.666667l0 0q0-42.666667 42.666667-42.666666Z"
      fill="currentColor"
    />
  </svg>
)

const IconComponent = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={Svg} {...props} />
)

export default IconComponent